import axiosInstance from "../../utils/axiosInstance";
import { getAuthHeaders } from "../../utils/authHeader";

const BASE_URL = `/platform`;

export const fetchPlatforms = async () => {
  const res = await axiosInstance.get(BASE_URL, getAuthHeaders());
  return res.data;
};

export const fetchPlatformsByAccountId = async (accountId) => {
  const res = await axiosInstance.get(
    `${BASE_URL}/account/${accountId}`,
    getAuthHeaders()
  );
  return res.data;
};

export const fetchPlatformById = async (uuid) => {
  const res = await axiosInstance.get(`${BASE_URL}/${uuid}`, getAuthHeaders());
  return res.data;
};

export const createPlatform = async (data) => {
  const res = await axiosInstance.post(BASE_URL, data, getAuthHeaders());
  return res.data;
};

export const updatePlatform = async (id, data) => {
  const res = await axiosInstance.put(
    `${BASE_URL}/${id}`,
    data,
    getAuthHeaders()
  );
  return res.data;
};

export const deletePlatform = async (uuid) => {
  const res = await axiosInstance.delete(
    `${BASE_URL}/${uuid}`,
    getAuthHeaders()
  );
  return res.data;
};

export const deletePlatformByPlatformAPI = async (platformId) => {
  const res = await axiosInstance.delete(
    `${BASE_URL}/platform/${platformId}`,
    getAuthHeaders()
  );
  return res.data;
};

export const fetchPlatformConfigurations = async ({
  settingId,
  workspaceGid,
  projectGid
}) => {
  const res = await axiosInstance.post(
    `${BASE_URL}/configurations`,
    { settingId, workspaceGid, projectGid },
    getAuthHeaders()
  );
  return res.data;
};
